// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchHistory_container__UwtT_"};